import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";
import { Loader2, ScrollText } from "lucide-react";

const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("pt-BR", { timeZone: "America/Cuiaba" });
};

const OP_CLS = {
  criou: "bg-blue-50 text-blue-700 border-blue-200",
  alterou: "bg-amber-50 text-amber-700 border-amber-200",
  pagou: "bg-emerald-50 text-emerald-700 border-emerald-200",
  recebeu: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelou: "bg-rose-50 text-rose-700 border-rose-200",
  inativou: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-6">
      <PageHeader title="Auditoria" subtitle="Registro das operações realizadas no sistema" />
      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-brand" /></div>
        : rows.length === 0 ? <EmptyState text="Nenhuma operação registrada." />
        : (
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm divide-y divide-slate-100" data-testid="audit-list">
          {rows.map((r) => (
            <div key={r.id} className="flex items-start gap-4 px-5 py-4" data-testid={`audit-row-${r.id}`}>
              <div className="h-9 w-9 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0"><ScrollText className="h-4 w-4 text-slate-400" /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className={`text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full border ${OP_CLS[r.operation] || "bg-slate-100 text-slate-600 border-slate-200"}`}>{r.operation}</span>
                  <span className="text-xs text-slate-400">{r.module?.replaceAll("_", " ")}</span>
                </div>
                <p className="text-sm text-slate-700 mt-1">{r.description}</p>
                <div className="text-xs text-slate-400 mt-1">{r.user_name} · {fmtDateTime(r.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
